import React from 'react'
import Alert from '@/components/ui/Alert'
import Button from '@/components/ui/Buttons/Button'
import { useUpdateRoute } from '@/lib/react-query'

export type NoAuthAlertProps = {
  projectId: number
  routeId: number
}

const NoAuthAlert = ({ projectId, routeId }: NoAuthAlertProps) => {
  const updateRoute = useUpdateRoute(projectId, routeId)

  return (
    <Alert
      color={'warning'}
      endAdornment={
        <Button
          color={'warning'}
          variant={'soft'}
          onClick={() => updateRoute.mutate({ route: { authEnabled: true } })}
          disabled={updateRoute.isPending}
        >
          Enable
        </Button>
      }
    >
      No authentication is currently enabled. We recommend enabling authentication to secure your route. However, you
      may continue to use the route without authentication if necessary.
    </Alert>
  )
}

export default NoAuthAlert
